<template>
    <div>
        <bc-circle-loader v-if="loading == true"></bc-circle-loader>
        <v-container v-else fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ fe_invoice.invoice_id ? $t("lang.edit_fe_invoice") : $t("lang.add_fe_invoice") }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh v-if="fe_invoice.invoice_id && fe_invoice.invoice_id > 0" @invoke-method="dbGetFeInvoice(true)"></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="fe_invoice.invoice_id && fe_invoice.invoice_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print Invoice </v-list-tile-title>
                                </v-list-tile>

                                <v-list-tile v-if="current_user.slug != 'customer'" @click="setEmailDialog()">
                                    <v-list-tile-title>Email Invoice</v-list-tile-title>
                                    <v-divider class="ml-3 my-0"></v-divider>
                                </v-list-tile>

                                <v-list-tile
                                    v-if="fe_invoice.status_id != 168 && fe_invoice.invoice_id && current_user.slug != 'customer'"
                                    @click="setupFeInvoicePaymentDialog(null)"
                                >
                                    <v-list-tile-title> Enter Payment </v-list-tile-title>
                                </v-list-tile>
                                <!-- <template v-if="hasPerm('fe_invoices.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in fe_invoice_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != fe_invoice.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template> -->
                                <!-- <v-divider class="ml-3 my-0"></v-divider> -->
                                <v-list-tile v-if="current_user.slug != 'customer'" @click="flipCurrency">
                                    <v-list-tile-title v-if="convert_currency">View as Company</v-list-tile-title>
                                    <v-list-tile-title v-else>View as Customer</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="hasPerm('fe_invoices.approval')" @click="approveUnapproveFeInvoice()">
                                    <v-list-tile-title>{{ fe_invoice.approved == 1 ? "Unapprove" : "Approve" }}</v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('fe_invoices.delete') && fe_invoice.fe_invoice_payments == null">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_fe_invoice.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'fe_invoices' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-container fluid grid-list-xl :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <bc-transaction-links :items="fe_invoice.transaction_links" :object_id="fe_invoice.invoice_id"></bc-transaction-links>
                    <v-flex :class="fe_invoice.invoice_id != null ? 'lg10 md9 xs12' : 'lg12 md12 xs12'" pb-0 mb-0>
                        <v-card elevation="0">
                            <v-card-text :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                                <div v-if="fe_invoice.status" class="ribbon ribbon-top-right" :class="`ribbon-${fe_invoice.status_class}`">
                                    <span class="ribbon-span">{{ fe_invoice.status }}</span>
                                </div>

                                <vue-perfect-scrollbar
                                    class="scroll-area"
                                    :style="$bp.xs ? null : 'max-height: calc(100vh - 260px); min-height: calc(100vh - 260px)'"
                                >
                                    <v-card-text v-if="fe_invoice.fe_invoice_payments != null" :class="$bp.smallScreen ? 'pa-0' : null">
                                        <v-card
                                            color="grey lighten-4 mb-2"
                                            elevation="0"
                                            @click="showFeInvoicePayments = !showFeInvoicePayments"
                                            class="underline-on-hover"
                                            style="cursor: pointer"
                                        >
                                            <v-card-title
                                                ><label style="cursor: pointer"
                                                    >Payments Received ({{ fe_invoice.fe_invoice_payments.length }})</label
                                                ></v-card-title
                                            >
                                        </v-card>
                                        <div :class="{ 'slide-up': !showFeInvoicePayments, 'slide-down': showFeInvoicePayments }">
                                            <v-card v-if="showFeInvoicePayments" class="slide-container" elevation="0" style="background: transparent">
                                                <v-data-table
                                                    :headers="invoice_payment_headers"
                                                    :items="fe_invoice.fe_invoice_payments"
                                                    :no-data-text="$t('lang.no_results_matching')"
                                                    hide-actions
                                                >
                                                    <template slot="items" slot-scope="props">
                                                        <tr class="clickable" @mouseup.left="setupFeInvoicePaymentDialog(props.item)">
                                                            <td>{{ props.item.payment_id }}</td>
                                                            <td>{{ props.item.invoice_id }}</td>
                                                            <td>{{ props.item.company }}</td>
                                                            <td>{{ props.item.payment_date }}</td>
                                                            <td>{{ props.item.amount }}</td>
                                                            <td>{{ props.item.payment_method }}</td>
                                                            <td>
                                                                <v-chip
                                                                    disabled
                                                                    round
                                                                    text-color="white"
                                                                    class="fs-14 text-center"
                                                                    :color="props.item.status_class"
                                                                >
                                                                    <span style="min-width: 60px">{{ props.item.payment_status }}</span>
                                                                </v-chip>
                                                            </td>
                                                            <td>{{ props.item.reference_number }}</td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                                <!-- <bc-pagination :page="page" :params="axiosParams" name="invoice_payments"></bc-pagination> -->
                                                <v-divider horizontal></v-divider>
                                            </v-card>
                                        </div>
                                    </v-card-text>
                                    <v-form ref="formFeInvoice">
                                        <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                            <v-flex xs12 sm6 row-2-fr1>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12>
                                                        <bc-autocomplete
                                                            v-if="fe_invoice.status_id != 168"
                                                            v-model="fe_invoice.company_id"
                                                            :label="`${$t('lang.company_id')} *`"
                                                            :items="filter_customer_options"
                                                            item-value="company_id"
                                                            item-text="company"
                                                            :rules="ifValid('fe_invoices.company_id')"
                                                            @change="selectCustomer(fe_invoice.company_id)"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-autocomplete>
                                                        <bc-autocomplete
                                                            v-else
                                                            v-model="fe_invoice.company_id"
                                                            :label="`${$t('lang.company_id')} *`"
                                                            :items="filter_customer_options"
                                                            item-value="company_id"
                                                            item-text="company"
                                                            append-icon="lock"
                                                            disabled
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <div
                                                            class="customer-address"
                                                            v-if="fe_invoice.billing_address_id != null"
                                                            style="padding: 0px 12px 12px 12px"
                                                        >
                                                            <h3>
                                                                {{ $t("lang.billing_address_id") }}
                                                                <v-btn
                                                                    v-if="fe_invoice.status_id != 168 && current_user.slug != 'customer'"
                                                                    color="secondary"
                                                                    icon
                                                                    small
                                                                    @mouseup.left="changeAddress('bill_address')"
                                                                >
                                                                    <v-icon small>edit</v-icon>
                                                                </v-btn>
                                                            </h3>
                                                            <div>
                                                                <div v-if="fe_invoice.bill_location_label">
                                                                    {{ fe_invoice.bill_location_label }}
                                                                </div>
                                                                <div>
                                                                    {{ fe_invoice.bill_address1 }}
                                                                </div>
                                                                <div v-if="fe_invoice.bill_address2 != ''">
                                                                    {{ fe_invoice.bill_address2 }}
                                                                </div>
                                                                <div>
                                                                    {{ fe_invoice.bill_city }}, {{ fe_invoice.bill_state }},
                                                                    {{ fe_invoice.bill_zip_code }}
                                                                </div>
                                                                <div>
                                                                    {{ fe_invoice.bill_country_iso_3 }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <div
                                                            class="customer-address"
                                                            v-if="fe_invoice.shipping_address_id != null"
                                                            style="padding: 0px 12px 12px 12px"
                                                        >
                                                            <h3>
                                                                {{ $t("lang.shipping_address_id") }}
                                                                <v-btn
                                                                    v-if="fe_invoice.status_id != 168 && current_user.slug != 'customer'"
                                                                    color="secondary"
                                                                    icon
                                                                    small
                                                                    @mouseup.left="changeAddress('ship_address')"
                                                                >
                                                                    <v-icon small>edit</v-icon>
                                                                </v-btn>
                                                            </h3>
                                                            <div>
                                                                <div v-if="fe_invoice.ship_location_label">
                                                                    {{ fe_invoice.ship_location_label }}
                                                                </div>
                                                                <div>
                                                                    {{ fe_invoice.ship_address1 }}
                                                                </div>
                                                                <div v-if="fe_invoice.ship_address2 != ''">
                                                                    {{ fe_invoice.ship_address2 }}
                                                                </div>
                                                                <div>
                                                                    {{ fe_invoice.ship_city }}, {{ fe_invoice.ship_state }},
                                                                    {{ fe_invoice.ship_zip_code }}
                                                                </div>
                                                                <div>
                                                                    {{ fe_invoice.ship_country_iso_3 }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 sm6>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        v-if="fe_invoice.invoice_id"
                                                        v-model="fe_invoice.invoice_id"
                                                        :label="$t('lang.invoice_id')"
                                                        :counter="showCounter(fe_invoice.invoice_id, 'fe_invoices.invoice_id')"
                                                        :rules="ifValid('fe_invoices.invoice_id')"
                                                        disabled
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-date-picker
                                                            v-model="fe_invoice.invoice_date"
                                                            :label="$t('lang.invoice_date')"
                                                            :rules="ifValid('fe_invoices.invoice_date')"
                                                            :is_disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-date-picker>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <bc-date-picker
                                                            v-model="fe_invoice.due_date"
                                                            :label="`${$t('lang.due_date')} *`"
                                                            :rules="ifValid('fe_invoices.due_date')"
                                                            :is_disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-date-picker>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-model="fe_invoice.payment_term_id"
                                                            :label="`${$t('lang.payment_term')} *`"
                                                            :items="filter_payment_terms"
                                                            item-value="payment_term_id"
                                                            item-text="description"
                                                            :rules="ifValid('fe_invoices.payment_term_id')"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-text-field
                                                            v-model="fe_invoice.customer_po"
                                                            :label="$t('lang.customer_po')"
                                                            :rules="ifValid('fe_invoices.customer_po')"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout
                                                    row
                                                    wrap
                                                    :class="$bp.smallScreen ? 'mx-0' : null"
                                                    style="margin: 0px"
                                                    v-if="current_user.login_type_id != '2'"
                                                >
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-model="fe_invoice.currency_id"
                                                            :label="$t('lang.document_currency')"
                                                            :items="filter_currencies"
                                                            item-value="currency_id"
                                                            item-text="name"
                                                            :rules="ifValid('fe_invoices.currency_id')"
                                                            @change="setExchangeRate(fe_invoice.currency_id)"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-text-field
                                                            v-model="fe_invoice.exchange_rate"
                                                            :label="$t('lang.exchange_rate')"
                                                            :counter="showCounter(fe_invoice.exchange_rate, 'fe_invoices.exchange_rate')"
                                                            :rules="ifValid('fe_invoices.exchange_rate')"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs6>
                                                        <v-text-field
                                                            v-model="fe_invoice.work_order_no"
                                                            :label="$t('lang.work_order_no')"
                                                            :rules="ifValid('fe_invoices.work_order_no')"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs6 v-if="current_user.login_type_id == '1'">
                                                        <bc-autocomplete
                                                            v-model="fe_invoice.project_id"
                                                            :label="`${$t('lang.project')}`"
                                                            :items="projects"
                                                            item-value="project_id"
                                                            item-text="project_name"
                                                            :rules="ifValid('fe_invoices.project_id')"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>

                                        <div>
                                            <v-data-table
                                                :headers="fe_invoice_headers"
                                                :items="fe_invoice.fe_invoice_details || []"
                                                item-key="fe_invoice_detail_id"
                                                :no-data-text="$t('lang.no_results_matching')"
                                                hide-actions
                                                class="custom-table"
                                            >
                                                <template slot="items" slot-scope="props">
                                                    <tr>
                                                        <td>
                                                            <!-- <bc-autocomplete
                                                                v-model="props.item.part_id"
                                                                :items="filter_fe_part_options(props.item)"
                                                                item-value="part_id"
                                                                item-text="sales_sku"
                                                                @change="handleChangePart(props.index, props.item.part_id)"
                                                                :rules="ifValid('fe_invoices.fe_invoice_details.part_id')"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></bc-autocomplete> -->
                                                            <bc-autocomplete
                                                                v-if="props.item.part_id == null"
                                                                v-model="props.item.part_id"
                                                                :items="filter_fe_part_options(props.item)"
                                                                item-value="part_id"
                                                                item-text="sales_sku"
                                                                @change="handleChangePart(props.index, props.item.part_id)"
                                                                :rules="ifValid('fe_invoices.fe_invoice_details.part_id')"
                                                                :append-icon="current_user.login_type_id != '1' ? 'lock' : 'arrow_drop_down'"
                                                                :disabled="current_user.login_type_id != '1' ? true : false"
                                                                :filter="$filterFePartsSales"
                                                                :ref="`${props.index}_feinvoice_detail_id`"
                                                            >
                                                                <template slot="item" slot-scope="data">
                                                                    <v-list-tile-content>
                                                                        <v-list-tile-title
                                                                            ><strong>{{ data.item.sales_sku }}</strong></v-list-tile-title
                                                                        >
                                                                        <v-list-tile-sub-title v-html="data.item.name"></v-list-tile-sub-title>
                                                                        <v-list-tile-sub-title v-html="data.item.model_number"></v-list-tile-sub-title>
                                                                    </v-list-tile-content>
                                                                </template>
                                                            </bc-autocomplete>
                                                            <v-list-tile v-else class="full-height-tile">
                                                                <v-list-tile-content>
                                                                    <v-list-tile-title
                                                                        ><strong>{{ props.item.sales_sku || props.item.sku }}</strong></v-list-tile-title
                                                                    >
                                                                    <v-list-tile-sub-title>{{ `Name: ${props.item.name}` }}</v-list-tile-sub-title>
                                                                    <v-list-tile-sub-title>{{ `Model: ${props.item.model_number}` }}</v-list-tile-sub-title>
                                                                </v-list-tile-content>
                                                                <v-list-tile-action style="position: absolute; top: 0px; right: 0px; align-items: normal">
                                                                    <v-btn icon ripple @click="resetLine(props.index, props.item)">
                                                                        <v-icon color="grey lighten-1">cancel</v-icon>
                                                                    </v-btn>
                                                                </v-list-tile-action>
                                                            </v-list-tile>
                                                        </td>
                                                        <td>
                                                            <v-text-field v-model="props.item.hts_code" disabled></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                v-model="props.item.quantity"
                                                                :counter="showCounter(props.item.quantity, 'fe_invoices.fe_invoice_details.quantity')"
                                                                :rules="ifValid('fe_invoices.fe_invoice_details.quantity')"
                                                                :ref="`${props.index}_quantity`"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <bc-autocomplete
                                                                v-model="props.item.sales_unit"
                                                                :items="filter_sales_units(props.item)"
                                                                item-value="option_id"
                                                                item-text="option"
                                                                :rules="ifValid('fe_invoices.fe_invoice_details.sales_unit')"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></bc-autocomplete>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                :prefix="
                                                                    convert_currency == true && fe_invoice.currency_prefix != null
                                                                        ? fe_invoice.currency_prefix
                                                                        : '$'
                                                                "
                                                                :suffix="
                                                                    convert_currency == true && fe_invoice.currency_suffix != null
                                                                        ? fe_invoice.currency_suffix
                                                                        : ''
                                                                "
                                                                v-model="props.item.unit_price"
                                                                :counter="showCounter(props.item.unit_price, 'fe_invoices.fe_invoice_details.unit_price')"
                                                                :rules="ifValid('fe_invoices.fe_invoice_details.unit_price')"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></v-text-field>
                                                        </td>
                                                        <td style="display: flex">
                                                            <v-text-field
                                                                class="pr-3"
                                                                v-if="props.item.line_discount_type == 'P'"
                                                                v-model="props.item.line_discount_percentage"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></v-text-field>
                                                            <v-text-field
                                                                class="pr-3"
                                                                v-else-if="props.item.line_discount_type == 'A'"
                                                                v-model="props.item.line_discount_amount"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></v-text-field>
                                                            <v-btn
                                                                v-if="current_user.slug != 'customer'"
                                                                x-small
                                                                raised
                                                                class="ma-0 pa-0"
                                                                style="min-width: 25px !important"
                                                                @click="setDetailDiscount(props.index)"
                                                            >
                                                                {{
                                                                    convert_currency == true
                                                                        ? fe_invoice.currency_prefix != null && props.item.line_discount_type == "A"
                                                                            ? fe_invoice.currency_prefix
                                                                            : "%"
                                                                        : props.item.line_discount_type == "P"
                                                                        ? "%"
                                                                        : "$"
                                                                }}
                                                            </v-btn>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                :prefix="
                                                                    convert_currency == true && fe_invoice.currency_prefix != null
                                                                        ? fe_invoice.currency_prefix
                                                                        : '$'
                                                                "
                                                                v-model="props.item.line_total"
                                                                disabled
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-icon v-if="current_user.slug != 'customer'" @click="removeRow(props.index)">delete</v-icon>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </div>
                                        <v-card class="mx-auto mb-4" elevation="0">
                                            <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                                                    <v-flex xs12 sm8>
                                                        <v-container fluid class="pa-0">
                                                            <v-btn
                                                                v-if="fe_invoice.status_id != 168 && current_user.slug != 'customer'"
                                                                x-small
                                                                raised
                                                                color="primary"
                                                                @click="addRow()"
                                                                >{{ $t("lang.add_more") }}</v-btn
                                                            >
                                                        </v-container>
                                                    </v-flex>
                                                    <v-flex xs12 sm4>
                                                        <table style="width: 100%">
                                                            <tbody>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">
                                                                        {{ $t("lang.subtotal") }}
                                                                    </th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && fe_invoice.currency_prefix != null
                                                                                    ? fe_invoice.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && fe_invoice.currency_suffix != null
                                                                                    ? fe_invoice.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="fe_invoice.subtotal"
                                                                            :counter="showCounter(fe_invoice.subtotal, 'fe_invoices.subtotal')"
                                                                            :rules="ifValid('fe_invoices.subtotal')"
                                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.discount") }}</th>
                                                                    <td>
                                                                        <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                                                                            <v-flex xs11 class="pr-3" :class="$bp.smallScreen ? 'pl-0' : null">
                                                                                <v-text-field
                                                                                    v-model="fe_invoice.discount"
                                                                                    :counter="showCounter(fe_invoice.discount, 'fe_invoices.discount')"
                                                                                    :rules="ifValid('fe_invoices.discount')"
                                                                                    :disabled="current_user.slug == 'customer' ? true : false"
                                                                                ></v-text-field>
                                                                            </v-flex>
                                                                            <v-flex xs1 class="pl-0">
                                                                                <v-container fluid class="pa-0">
                                                                                    <v-btn
                                                                                        v-if="current_user.slug != 'customer'"
                                                                                        class="ma-0 pa-0"
                                                                                        x-small
                                                                                        raised
                                                                                        style="min-width: 25px !important"
                                                                                        @click="setDiscount(fe_invoice.discount_type)"
                                                                                    >
                                                                                        {{
                                                                                            convert_currency == true
                                                                                                ? fe_invoice.currency_prefix != null &&
                                                                                                  fe_invoice.discount_type == "A"
                                                                                                    ? fe_invoice.currency_prefix
                                                                                                    : "%"
                                                                                                : fe_invoice.discount_type == "P"
                                                                                                ? "%"
                                                                                                : "$"
                                                                                        }}
                                                                                    </v-btn>
                                                                                </v-container>
                                                                            </v-flex>
                                                                        </v-layout>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.freight") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && fe_invoice.currency_prefix != null
                                                                                    ? fe_invoice.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && fe_invoice.currency_suffix != null
                                                                                    ? fe_invoice.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="fe_invoice.freight"
                                                                            :counter="showCounter(fe_invoice.freight, 'fe_invoices.freight')"
                                                                            :rules="ifValid('fe_invoices.freight')"
                                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.customs") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && fe_invoice.currency_prefix != null
                                                                                    ? fe_invoice.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && fe_invoice.currency_suffix != null
                                                                                    ? fe_invoice.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="fe_invoice.customs"
                                                                            :counter="showCounter(fe_invoice.customs, 'fe_invoices.customs')"
                                                                            :rules="ifValid('fe_invoices.customs')"
                                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.expedite_fee") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && fe_invoice.currency_prefix != null
                                                                                    ? fe_invoice.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && fe_invoice.currency_suffix != null
                                                                                    ? fe_invoice.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="fe_invoice.expedite_fee"
                                                                            :counter="showCounter(fe_invoice.expedite_fee, 'fe_invoices.expedite_fee')"
                                                                            :rules="ifValid('fe_invoices.expedite_fee')"
                                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.handling_charge") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && fe_invoice.currency_prefix != null
                                                                                    ? fe_invoice.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && fe_invoice.currency_suffix != null
                                                                                    ? fe_invoice.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="fe_invoice.handling_charge"
                                                                            :counter="showCounter(fe_invoice.handling_charge, 'fe_invoices.handling_charge')"
                                                                            :rules="ifValid('fe_invoices.handling_charge')"
                                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.total_amount") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && fe_invoice.currency_prefix != null
                                                                                    ? fe_invoice.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && fe_invoice.currency_suffix != null
                                                                                    ? fe_invoice.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="fe_invoice.total_amount"
                                                                            :counter="showCounter(fe_invoice.total_amount, 'fe_invoices.total_amount')"
                                                                            :rules="ifValid('fe_invoices.total_amount')"
                                                                            disabled
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.balance") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && fe_invoice.currency_prefix != null
                                                                                    ? fe_invoice.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && fe_invoice.currency_suffix != null
                                                                                    ? fe_invoice.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="fe_invoice.balance"
                                                                            disabled
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                        </v-card>
                                        <v-flex xs12>
                                            <v-textarea
                                                v-model="fe_invoice.comments"
                                                :label="$t('lang.comments')"
                                                auto-grow
                                                rows="1"
                                                :rules="ifValid('fe_invoices.comments')"
                                                :disabled="current_user.slug == 'customer' ? true : false"
                                            ></v-textarea>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <bc-autocomplete
                                                v-model="fe_invoice.department_id"
                                                :label="$t('lang.department')"
                                                :items="department_options"
                                                item-value="department_id"
                                                item-text="department_name"
                                                :rules="ifValid('fe_invoices.department_id')"
                                                :disabled="current_user.slug == 'customer' ? true : false"
                                            ></bc-autocomplete>
                                        </v-flex>
                                    </v-form>
                                </vue-perfect-scrollbar>
                            </v-card-text>
                            <v-card-actions v-if="(!convert_currency && hasPerm('fe_invoices.approval')) || fe_invoice.approved == 1">
                                <v-spacer></v-spacer>
                                <v-btn v-if="fe_invoice.status_id != 168" @mouseup.left="$router.push({ name: 'fe_invoices' })" flat>{{
                                    $t("lang.cancel")
                                }}</v-btn>
                                <v-btn v-if="fe_invoice.status_id != 168 && current_user.slug != 'customer'" color="success" @click="saveFeInvoices">{{
                                    $t("lang.save")
                                }}</v-btn>
                            </v-card-actions>
                            <v-card-actions v-else-if="convert_currency" style="width: 100%" class="pa-0">
                                <v-alert style="width: 100%; padding: 12px !important" :value="true" type="warning" color="#f78c00">{{
                                    $t("lang.warn_viewing_as_customer")
                                }}</v-alert>
                            </v-card-actions>
                            <v-card-actions v-else style="width: 100%" class="pa-0">
                                <v-alert style="width: 100%; padding: 12px !important" :value="true" type="warning" color="#f78c00"
                                    >Waiting for Approval.</v-alert
                                >
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

            <bc-dialog :value="invoice_payment_dialog">
                <v-card>
                    <v-form ref="form_invoice_payment">
                        <v-card-title>
                            <span class="headline">{{
                                invoice_payment.payment_id == null ? $t("lang.add_fe_invoice_payment") : $t("lang.edit_fe_invoice_payment")
                            }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeFeInvoicePaymentDialog"
                                :dialog-status="invoice_payment_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="invoice_payment.due_date"
                                            :label="$t('lang.due_date')"
                                            :rules="ifValid('fe_invoice_payments.due_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="invoice_payment.payment_date"
                                            :label="$t('lang.payment_date')"
                                            :rules="ifValid('fe_invoice_payments.payment_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="invoice_payment.amount"
                                            :prefix="convert_currency == true && fe_invoice.currency_prefix != null ? fe_invoice.currency_prefix : '$'"
                                            :suffix="convert_currency == true && fe_invoice.currency_suffix != null ? fe_invoice.currency_suffix : ''"
                                            :label="$t('lang.amount')"
                                            :counter="showCounter(invoice_payment.amount, 'fe_invoice_payments.amount')"
                                            :rules="ifValid('fe_invoice_payments.amount')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="invoice_payment.payment_term_id"
                                            :label="`${$t('lang.payment_term')} *`"
                                            :items="payment_terms"
                                            item-value="payment_term_id"
                                            item-text="description"
                                            :rules="ifValid('fe_invoice_payments.payment_term_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <!-- <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="invoice_payment.currency_id"
                                            :label="$t('lang.document_currency')"
                                            :items="currencies"
                                            item-value="currency_id"
                                            item-text="name"
                                            :rules="ifValid('fe_invoice_payments.currency_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="invoice_payment.exchange_rate"
                                            :label="$t('lang.exchange_rate')"
                                            :counter="showCounter(invoice_payment.exchange_rate, 'fe_invoice_payments.exchange_rate')"
                                            :rules="ifValid('fe_invoice_payments.exchange_rate')"
                                        ></v-text-field>
                                    </v-flex> -->
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="invoice_payment.payment_method_id"
                                            :label="`${$t('lang.payment_method_id')} *`"
                                            :items="payment_methods"
                                            item-value="option_id"
                                            item-text="option"
                                            :rules="ifValid('fe_invoice_payments.payment_method_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="invoice_payment.payment_status_id"
                                            :label="`${$t('lang.payment_status_id')} *`"
                                            :items="payment_status"
                                            item-value="option_id"
                                            item-text="option"
                                            :rules="ifValid('fe_invoice_payments.payment_status_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="invoice_payment.reference_number"
                                            :label="$t('lang.reference_number')"
                                            :counter="showCounter(invoice_payment.reference_number, 'fe_invoice_payments.reference_number')"
                                            :rules="ifValid('fe_invoice_payments.reference_number')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="invoice_payment.notes"
                                            :label="$t('lang.notes')"
                                            :counter="showCounter(invoice_payment.notes, 'fe_invoice_payments.notes')"
                                            :rules="ifValid('fe_invoice_payments.notes')"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions v-if="!convert_currency">
                            <v-btn v-if="invoice_payment.payment_id" color="error" @mouseup.left="$refs.delete_fe_invoice_payments.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeFeInvoicePaymentDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn v-if="invoice_payment.payment_id == null" color="success" @click="createInvoicePayment">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>

            <bc-modal-email
                ref="emailDialog"
                :pdfReportName="`fe_invoice_${fe_invoice.invoice_id}.pdf`"
                :endPoint="`/fe_invoices/${fe_invoice.invoice_id}/email`"
            ></bc-modal-email>

            <bc-address-selector ref="select_address_dialog" @eventname="updateAddress"></bc-address-selector>
            <delete-confirmation-dialog
                ref="delete_fe_invoice"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_fe_invoice')"
                :message="$t('lang.delete_fe_invoice_confirm')"
                @onConfirm="deleteFeInvoices()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_fe_invoice_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteFeInvoiceDetails()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_fe_invoice_payments"
                :heading="$t('lang.delete_fe_invoice_payment')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteFeInvoicePayments(invoice_payment.payment_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import Vue from "vue";
import axios from "axios";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],
            fe_invoice_headers: [
                { text: this.$t("lang.part_id"), sortable: false, width: "25%" },
                { text: this.$t("lang.hts_code"), sortable: false, width: "5%" },
                { text: this.$t("lang.quantity"), sortable: false, width: "5%" },
                { text: this.$t("lang.sales_unit"), sortable: false, width: "10%" },
                // { text: this.$t("lang.lead_time"), sortable: false, width: "5%" },
                // { text: this.$t("lang.cost_price"), sortable: false, width: "10%" },
                { text: this.$t("lang.unit_price"), sortable: false, width: "10%" },
                {
                    text: this.$t("lang.discount"),
                    sortable: false,
                    width: "10%",
                },
                { text: this.$t("lang.line_total"), sortable: false, width: "10%" },
                { text: "", width: "3%", sortable: false },
            ],
            invoice_payment_headers: [
                { text: this.$t("lang.payment_id"), sortable: false, width: "9%" },
                { text: this.$t("lang.invoice_id"), sortable: false, width: "9%" },
                { text: this.$t("lang.company"), sortable: false, width: "9%" },
                { text: this.$t("lang.payment_date"), sortable: false, width: "9%" },
                { text: this.$t("lang.amount"), sortable: false, width: "9%" },
                { text: this.$t("lang.payment_method"), sortable: false, width: "9%" },
                { text: this.$t("lang.payment_status"), sortable: false, width: "9%" },
                { text: this.$t("lang.reference_number"), sortable: false, width: "9%" },
            ],
            formData: {},
            fe_invoice: {
                expedite_fee: "0.000",
                handling_charge: "0.000",
                discount_type: "A",
                freight: "0.000",
                customs: "0.000",
                subtotal: "0.000",
                discount: "0.000",
                total_amount: "0.000",
                fe_invoice_details: [],
                billing_address_id: null,
                shipping_address_id: null,
                bill_address: null,
                ship_address: null,
                address_options: [],
                currency_id: "1",
                exchange_rate: "1.000000",
                currency_prefix: "$",
                currency_suffix: "",
                currency_precision: 3,
            },
            file_name: "",
            people: [],
            dbGetFeInvoice: _.debounce(this.getFeInvoice, 1500, { maxWait: 1500, leading: true, trailing: false }),
            email_dialog: false,
            convert_currency: false,
            invoice_payment: {
                invoice_id: null,
                payment_id: null,
                company_id: null,
                due_date: new Date().toISOString().slice(0, 10),
                payment_date: new Date().toISOString().slice(0, 10),
                payment_term_id: "1",
                amount: "0.000",
                currency_id: "1",
                exchange_rate: "1.000",
                payment_method_id: "68",
                payment_status_id: "143",
                reference_number: null,
                notes: null,
            },
            invoice_payment_dialog: false,
            showFeInvoicePayments: false,
            loading: true,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchFeInvoice", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.fe_invoice) {
                        this.fe_invoice = this.assignObj2(data.fe_invoice, this.rules_fe_invoices);
                        if (this.current_user.login_type_id == "2") this.flipCurrency();
                        this.invoice_payment.company_id = this.fe_invoice.company_id;
                        this.invoice_payment.invoice_id = this.fe_invoice.invoice_id;
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "fe_invoices", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchFeInvoice", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.fe_invoice) {
                        next((vm) => {
                            vm.fe_invoice = vm.assignObj2(data.fe_invoice, vm.rules_fe_invoices);
                            if (vm.current_user.login_type_id == "2") vm.flipCurrency();
                            vm.invoice_payment.company_id = vm.fe_invoice.company_id;
                            vm.invoice_payment.invoice_id = vm.fe_invoice.invoice_id;

                            vm.$store.commit("toggleMainMenu", false);
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "fe_invoices", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("resetOptions");
        this.$store.commit("resetPeople");
        this.$store.commit("resetCustomers");
        this.$store.commit("resetCurrencies");
        this.$store.commit("resetFeParts");
        this.$store.commit("resetPaymentTerms");
        this.$store.commit("resetDepartments");
        this.$store.commit("resetShippingCarriers");
        this.$store.commit("resetProjects");
        next();
    },
    computed: {
        ...mapState({
            rules_fe_invoices: (state) => state.fe_invoices.rules_fe_invoices,
            fe_invoice_status_options: (state) => state.settings.fe_invoice_status_options,
            fe_invoices: (state) => state.fe_invoices.fe_invoices,
            selectedFeInvoice: (state) => state.fe_invoices.selectedFeInvoice,
            fe_part_options: (state) => state.fe_parts.fe_part_options,
            shipping_carriers: (state) => state.shipping_carriers.shipping_carrier_options,
            payment_terms: (state) => state.payment_terms.payment_term_options,
            department_options: (state) => state.departments.department_options,
            customer_options: (state) => state.customers.customer_options,
            freight_terms: (state) => state.options_categories.freight_terms,
            sales_units: (state) => state.options_categories.sales_units,
            fe_invoice_status: (state) => state.options_categories.fe_invoice_status,
            currencies: (state) => state.currencies.currencies,
            payment_methods: (state) => state.options_categories.payment_methods,
            payment_status: (state) => state.options_categories.payment_status,
            projects: (state) => state.projects.project_options,
        }),
        filter_customer_options() {
            return this.customer_options.filter((record) => !record.date_deleted || record.company_id === this.fe_invoice.company_id);
        },
        filter_freight_terms() {
            return this.freight_terms.filter((record) => !record.date_deleted || record.option_id === this.fe_invoice.freight_term_id);
        },
        filter_shipping_carriers() {
            return this.shipping_carriers.filter((record) => !record.date_deleted || record.company_id === this.fe_invoice.shipping_carrier_id);
        },
        filter_currencies() {
            return this.currencies.filter((record) => !record.date_deleted || record.currency_id === this.fe_invoice.currency_id);
        },
        filter_fe_part_options: function () {
            return function (item) {
                return this.fe_part_options.filter((record) => !record.date_deleted || record.part_id === item.part_id);
            };
        },
        filter_sales_units: function () {
            return function (item) {
                return this.sales_units.filter((record) => !record.date_deleted || record.option_id === item.sales_unit);
            };
        },
        filter_payment_terms() {
            return this.payment_terms.filter((record) => !record.date_deleted || record.option_id === this.fe_invoice.payment_term_id);
        },
        filter_department_options() {
            return this.department_options.filter((record) => !record.date_deleted || record.option_id === this.fe_invoice.department_option_id);
        },
    },
    watch: {
        fe_invoice: {
            handler: function (newValue) {
                if (!newValue.fe_invoice_details) newValue.fe_invoice_details = [];

                let subtotal = 0;
                for (let p of newValue.fe_invoice_details) {
                    if (p.line_discount_type == "A") {
                        p.line_total = (p.unit_price * p.quantity - p.line_discount_amount).toFixed(this.fe_invoice.currency_precision);
                        subtotal += parseFloat(p.line_total);
                    } else {
                        p.line_total = (p.unit_price * p.quantity - (p.unit_price * p.quantity * p.line_discount_percentage) / 100).toFixed(
                            this.fe_invoice.currency_precision
                        );
                        subtotal += parseFloat(p.line_total);
                    }
                }
                newValue.subtotal = subtotal.toFixed(this.fe_invoice.currency_precision);
                let total = subtotal;
                let discount = newValue.discount_type == "A" ? total - newValue.discount : total - (total * newValue.discount) / 100;
                total =
                    parseFloat(discount) +
                    parseFloat(newValue.expedite_fee) +
                    parseFloat(newValue.handling_charge) +
                    parseFloat(newValue.freight) +
                    parseFloat(newValue.customs);
                newValue.total_amount = total.toFixed(this.fe_invoice.currency_precision);
            },
            deep: true,
        },
    },
    methods: {
        ...mapActions([
            "fetchFeInvoice",
            "saveFeInvoice",
            "deleteFeInvoice",
            "printFeInvoice",
            "fetchFeParts",
            "fetchPaymentTerms",
            "fetchCurrencies",
            "fetchShippingCarriers",
            "fetchDepartments",
            "fetchCustomers",
            "fetchOptions",
            "saveFeInvoicePayment",
            "deleteFeInvoicePayment",
            "fetchProjects",
            "fetchFePart",
            "fetchCustomer",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        addRow() {
            if (!this.fe_invoice.fe_invoice_details) this.fe_invoice.fe_invoice_details = [];
            this.fe_invoice.fe_invoice_details.push({
                invoice_id: `${this.$route.params.id}`,
                quantity: "1",
                sales_unit: "",
                model_number: "",
                name: "",
                unit_price: "0.000",
                cost_price: "0.000",
                line_discount_type: "P",
                line_discount_percentage: "0.000",
                line_discount_amount: "0.000",
                line_total: "0.000",
            });
        },
        removeRow: function (index) {
            this.fe_invoice.fe_invoice_details.splice(index, 1);
        },
        changeAddress(type) {
            let address_list = this.fe_invoice.address_options ? this.fe_invoice.address_options : this.company.entity_addresses || [];
            this.$refs.select_address_dialog.showAddresses(address_list, type);
        },
        flipCurrency() {
            this.convert_currency = !this.convert_currency ? true : false;

            for (let p of this.fe_invoice.fe_invoice_details) {
                // if convert_currency is true, then convert the discount amount to the customer currency
                // calc cost_price, unit_price, line_discount_amount if amount
                if (this.convert_currency) {
                    p.cost_price = (p.cost_price * this.fe_invoice.exchange_rate).toFixed(this.fe_invoice.currency_precision);
                    p.unit_price = (p.unit_price * this.fe_invoice.exchange_rate).toFixed(this.fe_invoice.currency_precision);
                    if (p.line_discount_type == "A")
                        p.line_discount_amount = (p.line_discount_amount * this.fe_invoice.exchange_rate).toFixed(this.fe_invoice.currency_precision);
                } else {
                    p.cost_price = (p.cost_price / this.fe_invoice.exchange_rate).toFixed(this.fe_invoice.currency_precision);
                    p.unit_price = (p.unit_price / this.fe_invoice.exchange_rate).toFixed(this.fe_invoice.currency_precision);
                    if (p.line_discount_type == "A")
                        p.line_discount_amount = (p.line_discount_amount / this.fe_invoice.exchange_rate).toFixed(this.fe_invoice.currency_precision);
                }
            }
            // calc discount if amount, freight, customs, handling_charge, expedite_fee
            if (this.convert_currency) {
                if (this.fe_invoice.discount_type == "A")
                    this.fe_invoice.discount = (this.fe_invoice.discount * this.fe_invoice.exchange_rate).toFixed(this.fe_invoice.currency_precision);
                this.fe_invoice.freight = (this.fe_invoice.freight * this.fe_invoice.exchange_rate).toFixed(this.fe_invoice.currency_precision);
                this.fe_invoice.customs = (this.fe_invoice.customs * this.fe_invoice.exchange_rate).toFixed(this.fe_invoice.currency_precision);
                this.fe_invoice.expedite_fee = (this.fe_invoice.expedite_fee * this.fe_invoice.exchange_rate).toFixed(this.fe_invoice.currency_precision);
                this.fe_invoice.handling_charge = (this.fe_invoice.handling_charge * this.fe_invoice.exchange_rate).toFixed(this.fe_invoice.currency_precision);
            } else {
                if (this.fe_invoice.discount_type == "A")
                    this.fe_invoice.discount = (this.fe_invoice.discount / this.fe_invoice.exchange_rate).toFixed(this.fe_invoice.currency_precision);
                this.fe_invoice.freight = (this.fe_invoice.freight / this.fe_invoice.exchange_rate).toFixed(this.fe_invoice.currency_precision);
                this.fe_invoice.customs = (this.fe_invoice.customs / this.fe_invoice.exchange_rate).toFixed(this.fe_invoice.currency_precision);
                this.fe_invoice.expedite_fee = (this.fe_invoice.expedite_fee / this.fe_invoice.exchange_rate).toFixed(this.fe_invoice.currency_precision);
                this.fe_invoice.handling_charge = (this.fe_invoice.handling_charge / this.fe_invoice.exchange_rate).toFixed(this.fe_invoice.currency_precision);
            }
        },
        updateAddress(item, type) {
            if (type == "bill_address") {
                this.fe_invoice.billing_address_id = item.entity_addresses_id;
                this.fe_invoice.bill_location_label = item.location_label;
                this.fe_invoice.bill_address1 = item.address1;
                this.fe_invoice.bill_address2 = item.address2;
                this.fe_invoice.bill_city = item.city;
                this.fe_invoice.bill_state = item.state;
                this.fe_invoice.bill_zip_code = item.zip_code;
                this.fe_invoice.bill_zip_code_ext = item.zip_code_ext;
                this.fe_invoice.bill_country_iso_3 = item.country_iso_3;
            } else if (type == "ship_address") {
                this.fe_invoice.shipping_address_id = item.entity_addresses_id;
                this.fe_invoice.ship_location_label = item.location_label;
                this.fe_invoice.ship_address1 = item.address1;
                this.fe_invoice.ship_address2 = item.address2;
                this.fe_invoice.ship_city = item.city;
                this.fe_invoice.ship_state = item.state;
                this.fe_invoice.ship_zip_code = item.zip_code;
                this.fe_invoice.ship_zip_code_ext = item.zip_code_ext;
                this.fe_invoice.ship_country_iso_3 = item.country_iso_3;
            }
        },
        getFeInvoice(pg_refresh = false) {
            this.startLoader();

            this.fetchFeInvoice({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.fe_invoice) {
                    this.fe_invoice = this.assignObj2(data.fe_invoice, this.rules_fe_invoices);
                    this.convert_currency = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        emailInvoice() {},
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printFeInvoice({
                id: `${this.$route.params.id}`,
                view_as: this.convert_currency,
            }).then((data) => {
                if (typeof data != "undefined" && data.fe_invoice) {
                    if (this.dev_mode) {
                        this.file_name = data.fe_invoice.file_name;
                    } else {
                        this.$refs.print.printReport(data.fe_invoice.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        addPayment() {},
        saveFeInvoices() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formFeInvoice")) {
                    let body = this.prepForm(this.fe_invoice, this.rules_fe_invoices);

                    this.saveFeInvoice({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.fe_invoice) {
                            this.$router.push({ name: "fe_invoice", params: { id: data.fe_invoice.invoice_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { invoice_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveFeInvoice({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.fe_invoice) {
                    this.fe_invoice = this.assignObj2(data.fe_invoice, this.rules_fe_invoices);
                    this.convert_currency = false;
                }
            });
        },
        deleteFeInvoices() {
            this.deleteFeInvoice({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.$refs.delete_fe_invoice_details.close();
                    this.validationOff();
                    this.$router.push({ name: "fe_invoices" });
                }
                this.toggleModalLoader(false);
            });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "customers",
                    method: "get",
                    body: {
                        options: 1,
                    },
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.customers;
                        this.getCustomerAddresses(this.fe_invoice.company_id);
                    }
                });
        },
        selectCustomer(company_id) {
            if (company_id == null) {
                return;
            } else {
                this.fetchCustomer({ id: company_id }).then((data) => {
                    if (data.customer) {
                        this.company = data.customer;

                        this.fe_invoice.currency_id = this.company.currency_id;
                        this.fe_invoice.exchange_rate = this.company.exchange_rate;
                        this.fe_invoice.payment_term_id = this.company.payment_term_id;

                        var invoice_date = new Date();
                        var due_date = new Date();
                        due_date.setDate(invoice_date.getDate() + parseInt(this.company.payment_terms_days));
                        this.fe_invoice.invoice_date = invoice_date.toISOString().slice(0, 10);
                        this.fe_invoice.due_date = due_date.toISOString().slice(0, 10);

                        this.fe_invoice.address_options = this.company.entity_addresses ? this.company.entity_addresses : [];

                        let ship_address = this.company.entity_addresses ? this.company.entity_addresses.filter((x) => x.address_type == "shipping")[0] : null;
                        this.fe_invoice.shipping_address_id = ship_address && ship_address.entity_addresses_id ? ship_address.entity_addresses_id : null;
                        this.fe_invoice.ship_location_label = ship_address && ship_address.location_label ? ship_address.location_label : null;
                        this.fe_invoice.ship_address1 = ship_address && ship_address.address1 ? ship_address.address1 : null;
                        this.fe_invoice.ship_address2 = ship_address && ship_address.address2 ? ship_address.address2 : null;
                        this.fe_invoice.ship_city = ship_address && ship_address.city ? ship_address.city : null;
                        this.fe_invoice.ship_state = ship_address && ship_address.state ? ship_address.state : null;
                        this.fe_invoice.ship_zip_code = ship_address && ship_address.zip_code ? ship_address.zip_code : null;
                        this.fe_invoice.ship_zip_code_ext = ship_address && ship_address.zip_code_ext ? ship_address.zip_code_ext : null;
                        this.fe_invoice.ship_country_iso_3 = ship_address && ship_address.country_iso_3 ? ship_address.country_iso_3 : null;

                        let bill_address = this.company.entity_addresses ? this.company.entity_addresses.filter((x) => x.address_type == "billing")[0] : null;
                        this.fe_invoice.billing_address_id = bill_address && bill_address.entity_addresses_id ? bill_address.entity_addresses_id : null;
                        this.fe_invoice.bill_location_label = bill_address && bill_address.location_label ? bill_address.location_label : null;
                        this.fe_invoice.bill_address1 = bill_address && bill_address.address1 ? bill_address.address1 : null;
                        this.fe_invoice.bill_address2 = bill_address && bill_address.address2 ? bill_address.address2 : null;
                        this.fe_invoice.bill_city = bill_address && bill_address.city ? bill_address.city : null;
                        this.fe_invoice.bill_state = bill_address && bill_address.state ? bill_address.state : null;
                        this.fe_invoice.bill_zip_code = bill_address && bill_address.zip_code ? bill_address.zip_code : null;
                        this.fe_invoice.bill_zip_code_ext = bill_address && bill_address.zip_code_ext ? bill_address.zip_code_ext : null;
                        this.fe_invoice.bill_country_iso_3 = bill_address && bill_address.country_iso_3 ? bill_address.country_iso_3 : null;
                    } else {
                        return;
                    }
                });
            }
        },
        setDetailDiscount(index) {
            let part = this.fe_invoice.fe_invoice_details[index];
            if (part.line_discount_type == "P") {
                part.line_discount_type = "A";
                part.line_discount_amount = part.line_discount_percentage;
                part.line_discount_percentage = "0.000";
            } else {
                part.line_discount_type = "P";
                part.line_discount_percentage = part.line_discount_amount;
                part.line_discount_amount = "0.000";
            }
        },
        setDiscount() {
            if (this.fe_invoice.discount_type == "P" || this.fe_invoice.discount_type == "%") {
                this.fe_invoice.discount_type = "A";
            } else {
                this.fe_invoice.discount_type = "P";
            }
        },
        handleChangePart(index, part_id) {
            this.validationOff();
            // Get the part from the fe_part_options array based on the part_id
            let partObj = this.fe_part_options.find((x) => x.part_id == part_id);
            this.fetchFePart({ id: partObj.part_id }).then((data) => {
                if (typeof data !== "undefined" && data.fe_part) {
                    partObj = data.fe_part;
                    this.fe_invoice.fe_invoice_details[index].cost_price = partObj.part_cost;
                    this.fe_invoice.fe_invoice_details[index].unit_price = partObj.sales_price;
                    this.fe_invoice.fe_invoice_details[index].model_number = partObj.model_number;
                    this.fe_invoice.fe_invoice_details[index].sales_unit = partObj.sales_unit;
                    this.fe_invoice.fe_invoice_details[index].name = partObj.name;
                    this.fe_invoice.fe_invoice_details[index].lead_time = partObj.lead_time;
                    this.fe_invoice.fe_invoice_details[index].hts_code = partObj.hts_code;
                    this.fe_invoice.fe_invoice_details[index].sales_sku = partObj.sales_sku;
                    this.$refs[`${index}_quantity`].$el.querySelector("input").focus();
                }
            });
        },
        resetLine(index, item) {
            this.fe_invoice.fe_invoice_details[index].part_id = null;
            this.fe_invoice.fe_invoice_details[index].cost_price = null;
            this.fe_invoice.fe_invoice_details[index].unit_price = null;
            this.fe_invoice.fe_invoice_details[index].model_number = null;
            this.fe_invoice.fe_invoice_details[index].sales_unit = null;
            this.fe_invoice.fe_invoice_details[index].name = null;
            this.fe_invoice.fe_invoice_details[index].lead_time = null;
            this.fe_invoice.fe_invoice_details[index].hts_code = null;
            this.fe_invoice.fe_invoice_details[index].sales_sku = null;

            this.$nextTick(() => {
                this.$refs[`${index}_feinvoice_detail_id`].$children[0].focus();
                this.$refs[`${index}_feinvoice_detail_id`].$children[0].isMenuActive = true;
            });
        },
        setExchangeRate(currency_id) {
            let exchange_rate = this.currencies.find((x) => x.currency_id == currency_id);
            this.fe_invoice.currency_id = exchange_rate.currency_id;
            this.fe_invoice.exchange_rate = exchange_rate.exchange_rate ? exchange_rate.exchange_rate : "1.000000";
        },
        setEmailDialog() {
            this.validationOff();
            this.$refs.emailDialog.showEmail();
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchFeInvoice({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.fe_invoice) {
                        this.fe_invoice = this.assignObj2(data.fe_invoice, this.rules_fe_invoices);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            }

            if (this.fe_invoice.invoice_date == null || force == true) {
                var invoice_date = new Date();
                var due_date = new Date();
                due_date.setDate(invoice_date.getDate() + 30);
                this.fe_invoice.invoice_date = invoice_date.toISOString().slice(0, 10);
                this.fe_invoice.due_date = due_date.toISOString().slice(0, 10);
            }

            if (this.customer_options.length == 0 || force == true)
                this.fetchCustomers({ body: { options: 1, with_trashed: this.fe_invoice.invoice_id ? "1" : "0" } });

            if (this.currencies.length == 0 || force == true)
                this.fetchCurrencies({ body: { options: 1, with_trashed: this.fe_invoice.invoice_id ? "1" : "0" } });
            if (this.fe_part_options.length == 0 || force == true)
                this.fetchFeParts({ body: { options: 1, with_trashed: this.fe_invoice.invoice_id ? "1" : "0" } });

            if (this.freight_terms == 0 || force == true)
                this.fetchOptions({ body: { slug: "freight_terms", with_trashed: this.fe_invoice.invoice_id ? "1" : "0", options: 1 } });
            if (this.fe_invoice_status == 0 || force == true)
                this.fetchOptions({ body: { slug: "fe_invoice_status", with_trashed: this.fe_invoice.invoice_id ? "1" : "0", options: 1 } });
            if (this.sales_units == 0 || force == true)
                this.fetchOptions({ body: { slug: "sales_units", sort_by: "0", with_trashed: this.fe_invoice.invoice_id ? "1" : "0", options: 1 } });
            if (this.payment_terms.length == 0 || force == true)
                this.fetchPaymentTerms({ body: { options: 1, with_trashed: this.fe_invoice.invoice_id ? "1" : "0" } });
            if (this.department_options.length == 0 || force == true)
                this.fetchDepartments({ body: { options: 1, with_trashed: this.fe_invoice.invoice_id ? "1" : "0" } });

            if (!this.fe_invoice.department_id) this.fe_invoice.department_id = this.currUserField("department_id");

            if (this.shipping_carriers.length == 0 || force == true)
                this.fetchShippingCarriers({ body: { options: 1, with_trashed: this.fe_invoice.invoice_id ? "1" : "0", department_id: "1" } });

            if (this.payment_methods == 0 || force == true) this.fetchOptions({ body: { slug: "payment_methods", sort_by: "0", options: 1 } });
            if (this.payment_status == 0 || force == true) this.fetchOptions({ body: { slug: "payment_status", sort_by: "0", options: 1 } });
            if (this.projects.length == 0 || force == true) await this.fetchProjects({ body: { options: 1 } });

            this.loading = false;
            this.finishLoader();
        },
        closeFeInvoicePaymentDialog() {
            this.invoice_payment_dialog = false;
            this.invoice_payment = {
                invoice_id: this.fe_invoice.invoice_id,
                payment_id: null,
                company_id: this.fe_invoice.company_id,
                due_date: new Date().toISOString().slice(0, 10),
                payment_date: new Date().toISOString().slice(0, 10),
                payment_term_id: "1",
                amount: "0.000",
                currency_id: "1",
                exchange_rate: "1.000",
                payment_method_id: "68",
                payment_status_id: "143",
                reference_number: null,
                notes: null,
            };
            this.$refs.delete_fe_invoice_payments.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        createInvoicePayment() {
            if (parseInt(this.fe_invoice.balance) - parseInt(this.invoice_payment.amount) < 0) {
                let alert_message = this.$t("lang.payment_larger_than_balance");
                setTimeout(function () {
                    Vue.notify({
                        group: "loggedIn",
                        type: "error",
                        text: alert_message,
                    });
                }, 1000);
            } else {
                this.saveFeInvoicePayment({
                    body: this.invoice_payment,
                }).then((data) => {
                    if (typeof data != "undefined" && data.fe_invoice) {
                        this.invoice_payment_dialog = false;
                        this.invoice_payment = {
                            invoice_id: this.fe_invoice.invoice_id,
                            payment_id: null,
                            company_id: this.fe_invoice.company_id,
                            due_date: new Date().toISOString().slice(0, 10),
                            payment_date: new Date().toISOString().slice(0, 10),
                            payment_term_id: "1",
                            amount: "0.000",
                            currency_id: "1",
                            exchange_rate: "1.000",
                            payment_method_id: "68",
                            payment_status_id: "143",
                            reference_number: null,
                            notes: null,
                        };
                        this.fe_invoice = this.assignObj2(data.fe_invoice, this.rules_fe_invoices);

                        this.validationOff();
                        this.toggleModalLoader(false);
                    }
                });
            }
        },
        closeFeInvoicePaymentDialog() {
            this.invoice_payment_dialog = false;
            this.invoice_payment = {
                invoice_id: this.fe_invoice.invoice_id,
                payment_id: null,
                company_id: this.fe_invoice.company_id,
                due_date: new Date().toISOString().slice(0, 10),
                payment_date: new Date().toISOString().slice(0, 10),
                payment_term_id: "1",
                amount: "0.000",
                currency_id: "1",
                exchange_rate: "1.000",
                payment_method_id: "68",
                payment_status_id: "143",
                reference_number: null,
                notes: null,
            };
            this.$refs.delete_fe_invoice_payments.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        createFeInvoicePayment() {
            if (parseInt(this.fe_invoice.balance) - parseInt(this.invoice_payment.amount) < 0) {
                let alert_message = this.$t("lang.payment_larger_than_balance");
                setTimeout(function () {
                    Vue.notify({
                        group: "loggedIn",
                        type: "error",
                        text: alert_message,
                    });
                }, 1000);
            } else {
                this.saveFeInvoicePayment({
                    body: this.invoice_payment,
                }).then((data) => {
                    if (typeof data != "undefined" && data.bill) {
                        this.invoice_payment_dialog = false;
                        this.invoice_payment = {
                            invoice_id: this.fe_invoice.invoice_id,
                            payment_id: null,
                            company_id: this.fe_invoice.company_id,
                            payment_date: new Date().toISOString().slice(0, 10),
                            amount: "0.000",
                            currency_id: "1",
                            exchange_rate: "1.000",
                            payment_method_id: "68",
                            payment_status_id: "143",
                            reference_number: null,
                            notes: null,
                        };
                        this.bill = this.assignObj2(data.bill, this.rules_bills);

                        this.validationOff();
                        this.toggleModalLoader(false);
                    }
                });
            }
        },
        setupFeInvoicePaymentDialog(item = null) {
            this.invoice_payment_dialog = true;
            if (item != null) {
                this.invoice_payment = item;
            } else {
                this.invoice_payment.amount = this.fe_invoice.balance;
            }
        },
        deleteFeInvoicePayments(id = null) {
            this.deleteFeInvoicePayment({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.fe_invoice = this.assignObj2(data.fe_invoice, this.rules_fe_invoices);
                    this.closeFeInvoicePaymentDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },
        approveUnapproveFeInvoice() {
            if (this.fe_invoice.approved == 1) {
                this.fe_invoice.approved = 0;
            } else {
                this.fe_invoice.approved = 1;
            }

            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formFeInvoice")) {
                    let body = { invoice_id: `${this.$route.params.id}`, approved: this.fe_invoice.approved };

                    this.saveFeInvoice({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.fe_invoice) {
                            this.fe_invoice = this.assignObj2(data.fe_invoice, this.rules_fe_invoices);
                        }
                    });
                }
            });
        },
    },
};
</script>
<style lang="css">
.a-top table.v-table tbody tr td {
    vertical-align: top !important;
}

.custom-table .v-table tbody tr td {
    vertical-align: top !important;
}

.slide-container {
    transition: height 0.5s;
    overflow: hidden;
}

.slide-up {
    height: 0;
}

.slide-down {
    height: auto;
}

.underline-on-hover .v-card__title label {
    position: relative;
    display: inline-block;
}

.underline-on-hover .v-card__title label::after {
    content: " ";
    background-color: black;
    width: 0;
    position: absolute;
    left: 0;
    bottom: 2px;
    height: 1px;

    -webkit-transition: width 0.5s ease-in-out;
    -moz-transition: width 0.5s ease-in-out;
    -o-transition: width 0.5s ease-in-out;
    transition: width 0.5s ease-in-out;
}

.underline-on-hover:hover .v-card__title label::after {
    width: 100%;
}
</style>
